export default __webpack_public_path__ + "static/media/empty-box.6de54257.svg";